export enum BankAccountSource {
  SHINE_BANKING = 'SHINE_BANKING',
  OPEN_BANKING = 'OPEN_BANKING',
  BILLY = 'BILLY',
}
